var map = {
	"./upgrade-nudge-apps.svg": "GiBQ",
	"./upgrade-nudge-email-support.svg": "VSdr",
	"./upgrade-nudge-multistep.svg": "AMYt",
	"./upgrade-nudge-paths.svg": "Q4SF",
	"./upgrade-nudge-task-limit-80-percent.svg": "2fmH",
	"./upgrade-nudge-task-limit.svg": "5yKA",
	"./upgrade-nudge-zaps.svg": "wezH"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "D1Gw";